export default {
  // Options.jsx
  items_per_page: '/ strani',
  label_items_per_page: 'Items / page',
  jump_to: 'Idi na',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Prethodna strana',
  next_page: 'Sledeća strana',
  prev_5: 'Prethodnih 5 Strana',
  next_5: 'Sledećih 5 Strana',
  prev_3: 'Prethodnih 3 Strane',
  next_3: 'Sledećih 3 Strane',
};
